import React from 'react'
import PropTypes from 'prop-types'
import './FadeInFullscreen.scss'
import {
  disableBodyScroll,
  enableBodyScroll,
  clearAllBodyScrollLocks
} from 'body-scroll-lock' // This is because setting body overflow to hidden still allows users to scroll on iOS devices

class FadeInFullscreen extends React.Component {
  constructor (props) {
    super(props)

    this.fadeInElem = React.createRef()
  }

  componentDidUpdate (prevProps) {
    if (this.props.isOpen !== prevProps.isOpen) {
      if (this.props.isOpen) {
        disableBodyScroll(this.fadeInElem.current)
      } else {
        enableBodyScroll(this.fadeInElem.current)
      }
    }
  }

  componentDidMount () {
    this.body = document.querySelector('body')
    this.body.appendChild(this.fadeInElem.current)
  }

  componentWillUnmount () {
    clearAllBodyScrollLocks()
  }

  render () {
    return (
      <div
        className={`FadeInFullscreen ${
          this.props.isOpen ? 'FadeInFullscreen--visible' : ''
        }`}
        ref={this.fadeInElem}
      >
        <div className='FadeInFullscreen__backdrop' />
        <div className='FadeInFullscreen__content'>{this.props.children}</div>
      </div>
    )
  }
}

FadeInFullscreen.propTypes = {
  isOpen: PropTypes.bool
}

export default FadeInFullscreen
